<template>
  <div class="ServiceManage">
      <div>
          <el-form ref="ruleForm" label-width="100px">
                <el-row>
                    <el-col :span="5" v-if="this.str.system==1 && this.str.type == 1">
                        <el-form-item label="服务经理">
                            <el-select v-model="ruleForm.manager" placeholder="请选择" @change="Select1">
                                <el-option
                                    v-for="item in managerList"
                                    :key="item.rid"
                                    :label="item.roleUserName"
                                    :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" v-if="this.str.system==1 && this.str.type == 1">
                        <el-form-item label="常规客服">
                            <el-select v-model="ruleForm.conventional" placeholder="请选择" @change="Select2">
                                <el-option
                                    v-for="item in conventionalList"
                                    :key="item.rid"
                                    :label="item.roleUserName"
                                    :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" v-if="this.str.system==1 && this.str.type == 1">
                        <el-form-item label="仓库客服">
                            <el-select v-model="ruleForm.warehouse" placeholder="请选择" @change="Select3">
                                <el-option
                                    v-for="item in warehouseList"
                                    :key="item.rid"
                                    :label="item.roleUserName"
                                    :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    </el-row>
                    <el-row>
                    <el-col :span="5">
                        <el-form-item label="开始日期">
                            <el-date-picker
                                v-model="ruleForm.starttime"
                                type="date"
                                @change="startDate"
                                placeholder="选择开始日期"
                                format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="结束日期">
                            <el-date-picker
                                v-model="ruleForm.endtime"
                                type="date"
                                @change="endDate"
                                placeholder="选择结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label class="search">
                            <el-input v-model="ruleForm.input" placeholder="公司名称搜索" style="width: 60%;"></el-input>
                            <el-button type="primary" style="margin-left: 15px;" @click="search2">搜索</el-button>
                            <el-button type="primary" @click="searchReset">重置</el-button>
                        </el-form-item>
                    </el-col>
                    </el-row>
            </el-form>

            <div>
            <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column align="center" prop="companyCode" label="公司编码"></el-table-column>
                    <el-table-column align="center" prop="parentCompanyName" label="所属分公司"></el-table-column>
                    <el-table-column align="center" prop="companyFullName" label="公司全称"></el-table-column>
                    <el-table-column align="center" label="公司余额">
                        <template slot-scope="scope">
                            <p>实际余额：{{scope.row.balance}}</p>
                            <p>可用余额：{{scope.row.buckleBalance}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="legalPerson" label="法人名称"></el-table-column>
                    <el-table-column align="center" label="创建时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.createtime == null">-</span>
                            <span v-if="scope.row.createtime !== null">{{scope.row.createtime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="服务经理">
                        <template slot-scope="scope">
                            <span v-if="scope.row.serviceUserName == ''">-</span>
                            <el-tooltip class="item" effect="dark" :content="'联系电话：'+scope.row.serviceTelephone" placement="top">
                                <span v-if="scope.row.serviceUserName != ''">{{scope.row.serviceRoleName}}-{{scope.row.serviceUserName}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="常规客服">
                        <template slot-scope="scope">
                            <span v-if="scope.row.routineUserName == ''">-</span>
                            <el-tooltip class="item" effect="dark" :content="'联系电话：'+scope.row.routineTelephone " placement="top">
                                <span v-if="scope.row.routineUserName !== ''">{{scope.row.routineRoleName}}-{{scope.row.routineUserName}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="仓库客服">
                        <template slot-scope="scope">
                            <span v-if="scope.row.inventoryUserName == ''">-</span>
                            <el-tooltip class="item" effect="dark" :content="'联系电话：'+scope.row.inventoryTelephone" placement="top">
                                <span v-if="scope.row.inventoryUserName !== ''">{{scope.row.inventoryRoleName}}-{{scope.row.inventoryUserName}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="服务记录" width="170">
                        <template slot-scope="scope">
                            <el-button @click="operation(scope.row)" type="primary">操作</el-button>
                        </template>
                    </el-table-column>
            </el-table>
        </div>

        <el-dialog title="操作记录" :visible.sync="OperationRecords" width="60%">
            <el-button type="primary" @click="Addoperation = true">新增</el-button>
            <div style="margin-top:15px;">
                <el-table :data="OperationList" border style="width: 100%" v-loading="loading1">
                        <el-table-column align="center" prop="updateTime" label="操作时间"></el-table-column>
                        <el-table-column align="center" prop="operateTheme" label="操作主题"></el-table-column>
                        <el-table-column align="center" prop="handleResult" label="处理结果"></el-table-column>
                        <el-table-column align="center" label="是否参加过培训">
                            <template slot-scope="scope">
                                <span v-if="scope.row.trainStatus == 0">未培训</span>
                                <span v-if="scope.row.trainStatus == 1">已培训</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作人">
                            <template slot-scope="scope">
                                <span v-if="scope.row.userName!==null">{{scope.row.roleName}}-{{scope.row.userName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="otherRemark" label="其它备注"></el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <el-button type="primary" icon="el-icon-view" @click="ToView(scope.row)"></el-button>
                                <el-button type="success" icon="el-icon-edit" @click="Edit(scope.row)"></el-button>
                            </template>
                        </el-table-column>
                </el-table>
            </div>
            <div style="margin-top:15px;">
                <el-pagination
                        style="text-align:center;"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="currentPage1"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pagesize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </div>

            <el-dialog title="新增操作记录" :visible.sync="Addoperation" width="40%" append-to-body>
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="公司名称：">
                                <span>{{formData.companyFullName}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="创建时间：">
                                <span>{{formData.createtime}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="是否参加过培训">
                                <el-radio-group v-model="form.trainStatus">
                                    <el-radio :label="0">未培训</el-radio>
                                    <el-radio :label="1">有培训</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Tel：">
                                <span>{{formData.telephone}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item>
                        <p><span style="font-weight: bold;font-size:18px;">备注：</span>如果对子公司或者子公司店铺有以下操作，需要进行记录并备案。</p>
                        <p>如：员工培训、申请新店铺、店铺A-Z处理，店铺申诉、解封、店铺诊断、公司走访等。</p>
                    </el-form-item>
                    
                    <el-form-item label="操作主题" prop="operateTheme">
                        <el-input type="textarea" v-model="form.operateTheme"></el-input>
                    </el-form-item>

                    <el-form-item label="操作内容" prop="operateContent">
                        <el-input type="textarea" v-model="form.operateContent"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="处理结果" prop="handleResult">
                        <el-input type="textarea" v-model="form.handleResult"></el-input>
                    </el-form-item>

                    <el-form-item label="操作总结" prop="operateConclusion">
                        <el-input type="textarea" v-model="form.operateConclusion"></el-input>
                    </el-form-item>

                    <el-form-item label="其它备注" prop="otherRemark">
                        <el-input type="textarea" v-model="form.otherRemark"></el-input>
                    </el-form-item>

                    <div>
                        <p>
                            <span style="font-weight: bold;">目的：</span>
                            为了提高海逊的服务质量，规范总公司对加盟商的服务标准，特指定此表，请各公司负责人规范记录，严格执行。
                        </p>
                    </div>

                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="resetForm('ruleForm')">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </span>
            </el-dialog>

            <el-dialog title="编辑操作记录" :visible.sync="Editoperation" width="40%" append-to-body>
                <el-form ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="公司名称：">
                                <span>{{formData.companyFullName}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="创建时间：">
                                <span>{{formData.createtime}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="是否参加过培训">
                                <el-radio-group v-model="form.trainStatus1">
                                    <el-radio :label="0">未培训</el-radio>
                                    <el-radio :label="1">有培训</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Tel：">
                                <span>{{formData.telephone}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item>
                        <p><span style="font-weight: bold;font-size:18px;">备注：</span>如果对子公司或者子公司店铺有以下操作，需要进行记录并备案。</p>
                        <p>如：员工培训、申请新店铺、店铺A-Z处理，店铺申诉、解封、店铺诊断、公司走访等。</p>
                    </el-form-item>
                    
                    <el-form-item label="操作主题" prop="operateTheme">
                        <el-input type="textarea" v-model="form.operateTheme1"></el-input>
                    </el-form-item>

                    <el-form-item label="操作内容" prop="operateContent">
                        <el-input type="textarea" v-model="form.operateContent1"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="处理结果" prop="handleResult">
                        <el-input type="textarea" v-model="form.handleResult1"></el-input>
                    </el-form-item>

                    <el-form-item label="操作总结" prop="operateConclusion">
                        <el-input type="textarea" v-model="form.operateConclusion1"></el-input>
                    </el-form-item>

                    <el-form-item label="其它备注" prop="otherRemark">
                        <el-input type="textarea" v-model="form.otherRemark1"></el-input>
                    </el-form-item>

                    <div>
                        <p>
                            <span style="font-weight: bold;">目的：</span>
                            为了提高海逊的服务质量，规范总公司对加盟商的服务标准，特指定此表，请各公司负责人规范记录，严格执行。
                        </p>
                    </div>

                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="Editoperation = false">取消</el-button>
                    <el-button type="primary" @click="EditSub">提交</el-button>
                </span>
            </el-dialog>

            <el-dialog title="查看操作记录" :visible.sync="ToViewoperation" width="40%" append-to-body>
                <el-form ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="公司名称：">
                                <span>{{formData.companyFullName}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="创建时间：">
                                <span>{{formData.createtime}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="是否参加过培训">
                                <el-radio-group v-model="form.trainStatus1" disabled>
                                    <el-radio :label="0">未培训</el-radio>
                                    <el-radio :label="1">有培训</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Tel：">
                                <span>{{formData.telephone}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item>
                        <p><span style="font-weight: bold;font-size:18px;">备注：</span>如果对子公司或者子公司店铺有以下操作，需要进行记录并备案。</p>
                        <p>如：员工培训、申请新店铺、店铺A-Z处理，店铺申诉、解封、店铺诊断、公司走访等。</p>
                    </el-form-item>
                    
                    <el-form-item label="操作主题" prop="operateTheme">
                        <el-input type="textarea" v-model="form.operateTheme1" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="操作内容" prop="operateContent">
                        <el-input type="textarea" v-model="form.operateContent1" disabled></el-input>
                    </el-form-item>
                    
                    <el-form-item label="处理结果" prop="handleResult">
                        <el-input type="textarea" v-model="form.handleResult1" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="操作总结" prop="operateConclusion">
                        <el-input type="textarea" v-model="form.operateConclusion1" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="其它备注" prop="otherRemark">
                        <el-input type="textarea" v-model="form.otherRemark1" disabled></el-input>
                    </el-form-item>

                    <div>
                        <p>
                            <span style="font-weight: bold">目的：</span>
                            为了提高海逊的服务质量，规范总公司对加盟商的服务标准，特指定此表，请各公司负责人规范记录，严格执行。
                        </p>
                    </div>

                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="ToViewoperation = false">关闭</el-button>
                </span>
            </el-dialog>

        </el-dialog>

        <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
        </div>
        </div>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../api/api/api";
export default {
    name: "ServiceManage",
    data() {
        return {
            str:"",
            tableData:[],
            OperationList:[],
            loading:true,
            loading1:true,
            OperationRecords:false,
            Addoperation:false,
            Editoperation:false,
            ToViewoperation:false,
            EditId:"",
            companyId:"",
            formData:"",
            ruleForm:{
                manager:"",
                conventional:"",
                warehouse:"",
                starttime:"",
                endtime:"",
                input:""
            },
            form:{
                trainStatus:0,//培训状态
                operateTheme:"",//操作主题
                operateContent:"",//操作内容
                handleResult:"",//处理结果
                operateConclusion:"",//操作总结
                otherRemark:"",//其他备注

                trainStatus1:0,//培训状态
                operateTheme1:"",//操作主题
                operateContent1:"",//操作内容
                handleResult1:"",//处理结果
                operateConclusion1:"",//操作总结
                otherRemark1:"",//其他备注
            },
            managerList:[],
            conventionalList:[],
            warehouseList:[],

            currentPage: 1,
            pagesize: 20,
            size: 20,
            total: 0,

            currentPage1: 1,
            pagesize1: 20,
            size1: 20,
            total1: 0,

            rules: {
                operateTheme: [
                    { required: true, message: '请填写操作主题', trigger: 'blur' }
                ],
                operateContent: [
                    { required: true, message: '请填写操作内容', trigger: 'blur' }
                ],
                handleResult: [
                    { required: true, message: '请填写处理结果', trigger: 'blur' }
                ],
                operateConclusion: [
                    { required: true, message: '请填写操作总结', trigger: 'blur' }
                ],
                otherRemark: [
                    { required: true, message: '请填写其它备注', trigger: 'blur' }
                ],
            }
        };
    },
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.SelectAjax()
        this.search()
    },
    methods: {
      search2(){
          this.currentPage = 1
          this.search()
      },
      search(){
            this.loading = true
            var obj = {
                page:this.currentPage,
                size:this.size,
                startTime:this.ruleForm.starttime,
                endTime:this.ruleForm.endtime,
                searchString:this.ruleForm.input,
                serviceRid:this.ruleForm.manager,
                routineRid:this.ruleForm.conventional,
                inventoryRid:this.ruleForm.warehouse,
                signRid:this.str.rid
            }
            ajaxPost(Baseurl + "companyController/selectServiceManageList",obj).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.list
                    this.total = res.data.data.total
                }
                this.loading = false
            });
      },
      searchReset(){
          this.ruleForm.starttime = ""
          this.ruleForm.endtime = ""
          this.ruleForm.input = ""
          this.ruleForm.manager = ""
          this.ruleForm.conventional = ""
          this.ruleForm.warehouse = ""
          this.currentPage = 1
          this.search()
      },
      SelectAjax(){
            ajaxPost(Baseurl + "companyController/getServiceManageList").then(res => {
                if(res.data.code == 200){
                    this.managerList = res.data.data
                }
            });
            ajaxPost(Baseurl + "companyController/getRoutineManageList").then(res => {
                if(res.data.code == 200){
                    this.conventionalList = res.data.data
                }
            });
            ajaxPost(Baseurl + "companyController/getInventoryManageList").then(res => {
                if(res.data.code == 200){
                    this.warehouseList = res.data.data
                }
            });
      },
      Select1(){
            this.ruleForm.conventional = ""
            this.ruleForm.warehouse = ""
      },
      Select2(){
            this.ruleForm.manager = ""
            this.ruleForm.warehouse = ""
      },
      Select3(){
            this.ruleForm.manager = ""
            this.ruleForm.conventional = ""
      },
      operation(val){
          this.OperationRecords = true
          this.formData = val
          this.companyId = val.id
          this.OperationListAjax()
      },
      OperationListAjax(){
          this.loading1 = true
          var obj = {
            companyId:this.companyId,
            page:this.currentPage1,
            size:this.size1
          }
          ajaxPost(Baseurl + "serviceManageOperateController/selectServiceManageOperateList",obj).then(res => {
                if(res.data.code == 200){
                    this.OperationList = res.data.data.list
                    this.total1 = res.data.data.total
                }
                this.loading1 = false
          });
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var obj = {
                operateTheme:this.form.operateTheme,
                operateContent:this.form.operateContent,
                handleResult:this.form.handleResult,
                operateConclusion:this.form.operateConclusion,
                otherRemark:this.form.otherRemark,
                trainStatus:this.form.trainStatus,
                roleId:this.str.rid,
                companyId:this.companyId
            }
            ajaxPost(Baseurl + "serviceManageOperateController/insertServiceManageOperate",obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            type:"success",
                            message:"提交成功"
                        })
                        this.OperationListAjax()
                    }else{
                        this.$message.error(res.data.data)
                    }
                    this.Addoperation = false
                    this.$refs[formName].resetFields();
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.Addoperation = false
        this.$refs[formName].resetFields();
      },
      Edit(val){
          this.Editoperation = true
          this.EditId = val.id
          this.form.operateTheme1 = val.operateTheme
          this.form.operateContent1 = val.operateContent
          this.form.handleResult1 = val.handleResult
          this.form.operateConclusion1 = val.operateConclusion
          this.form.otherRemark1 = val.otherRemark
          this.form.trainStatus1 = val.trainStatus
      },
      EditSub(){
          var obj = {
                id:this.EditId,
                operateTheme:this.form.operateTheme1,
                operateContent:this.form.operateContent1,
                handleResult:this.form.handleResult1,
                operateConclusion:this.form.operateConclusion1,
                otherRemark:this.form.otherRemark1,
                trainStatus:this.form.trainStatus1,
                roleId:this.str.rid,
                companyId:this.companyId
        }
        ajaxPost(Baseurl + "serviceManageOperateController/updateServiceManageOperate",obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            type:"success",
                            message:"修改成功"
                        })
                        this.OperationListAjax()
                    }else{
                        this.$message.error(res.data.data)
                    }
                    this.Editoperation = false
        });
      },
      ToView(val){
          this.ToViewoperation = true
          this.form.operateTheme1 = val.operateTheme
          this.form.operateContent1 = val.operateContent
          this.form.handleResult1 = val.handleResult
          this.form.operateConclusion1 = val.operateConclusion
          this.form.otherRemark1 = val.otherRemark
          this.form.trainStatus1 = val.trainStatus
      },
      startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        },
        handleSizeChange1(val) {
            // console.log(`每页 ${val} 条`);
            this.size1 = val;
            this.OperationListAjax()
        },
        handleCurrentChange1(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage1 = val;
            this.OperationListAjax()
        },
    }
}
</script>
<style lang="scss" scoped>
/deep/ {
    .search .el-form-item__content{
        margin-left: 33px!important;
    }
}
</style>
<style>
.page {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}
.ServiceManage{
    margin-bottom: 50px;
}
</style>